import React from 'react'
import clsx from 'clsx'

const Textarea = ({
  label,
  placeholder,
  value,
  onChange,
  helperText,
  error,
  className = '',
  textareaClassName = '',
  labelClassName = '',
  wrapperClassName = '',
  rows = 4,
  canHaveError = true,
  ...props
}) => {
  const hasError = !!error 
  const hasHelperText = !!helperText && !hasError
  const displayError = error 

  return (
    <div
      className={clsx(
        'flex',
        'flex-col',
        'items-start',
        'w-full',
        wrapperClassName
      )}
    >
      {/* Label and Textarea Wrapper */}
      <div
        className={clsx(
          'flex',
          'flex-col',
          'items-start',
          'gap-v3-xs',
          'self-stretch',
          'w-full'
        )}
      >
        {/* Label */}
        {label && (
          <label
            className={clsx(
              'text-v3-h10',
              'font-[510]',
              'not-italic',
              'text-v3-black-max',
              labelClassName
            )}
          >
            {label}
          </label>
        )}

        {/* Textarea */}
        <textarea
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          rows={rows}
          className={clsx(
            'flex',
            'py-v3-xs',
            'px-3',
            'items-start',
            'self-stretch',
            'w-full',
            'rounded-v3-xs',
            'border',
            'font-regular',
            hasError ? 'border-v3-red-dark' : 'border-v3-black-inactive',
            'bg-white',
            'text-v3-h8',
            'placeholder:text-v3-black-placeholder',
             'text-v3-black-max',
            'placeholder:font-regular',
            'resize-y',
            'transition-all',
            textareaClassName
          )}
          {...props}
        />
      </div>

      {/* Helper Text / Error Text */}
      {canHaveError && (
        <div
        className={clsx(
          'flex',
          'pt-v3-xxs',
          'pl-3',
          'items-start',
          'gap-[10px]',
          'self-stretch',
          'min-h-[20px]'
        )}
      >
        {hasError ? (
          <span
            className={clsx(
              'text-v3-red-dark',
              'text-v3-h11',
              'font-normal',
              'not-italic'
            )}
          >
            {displayError}
          </span>
        ) : (
          <span
            className={clsx(
              'text-v3-black-secondary',
              'text-v3-h11',
              'font-normal',
              'italic'
            )}
          >
            {helperText}
          </span>
        )}
      </div>
      )}
    </div>
  )
}

export default Textarea

